import styled from 'styled-components';

const StyledButton = styled.button`
  background: #0ea5e9;
  color: #fff;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: background .2s ease;
  &:hover { background: #0284c7; }
`;

export default function Button({ children, ...props }) {
  return <StyledButton {...props}>{children}</StyledButton>;
}
